const redeemCreditsToast = (state = null, action) => {
  if (action.type === "SET_REDEEM_CREDITS_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_REDEEM_CREDITS_TOAST": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default redeemCreditsToast;
